<!-- <div class="header">
  <div class="container">
    <div class="header-content">
      <div class="logo">
        <i class="fas fa-anchor"></i>
        <span>MarinePortal Support</span>
      </div>
      <div class="user-info">
        <div class="user-avatar">{{ userInitials }}</div>
        <div>
          <div style="font-weight: 600;">{{ adminName }}</div>
          <div style="font-size: 14px; color: var(--gray-text);">{{ adminRole }}</div>
        </div>
      </div>
    </div>
  </div>
</div> -->

<div class="container admin-screen active">
  <!-- <div class="view-tabs">
    <button class="view-tab" type="button">User View</button>
    <button class="view-tab active" type="button">Admin View (mps&#64;varuna-sentinels.com)</button>
  </div> -->

  <div class="dashboard-title">
    <h1>Admin Support Dashboard</h1>
    <p>Manage all support tickets from suppliers and buyers. Access to all submitted documents and details.</p>
  </div>

  <div class="admin-controls">
    <div class="search-box">
      <i class="fas fa-search"></i>
      <input
        type="text"
        style="padding: 12px 15px 12px 45px !important;"
        placeholder="Search tickets by ID, subject, or email..."
        [(ngModel)]="searchQuery"
        (keyup.enter)="onSearchChange()"
        (blur)="onSearchChange()"
      />
    </div>
    <div class="filter-buttons">
      <button class="filter-btn" [class.active]="filterStatus === 'all'" (click)="setFilter('all')">All</button>
      <button class="filter-btn" [class.active]="filterStatus === 'open'" (click)="setFilter('open')">Open</button>
      <button class="filter-btn" [class.active]="filterStatus === 'inProgress'" (click)="setFilter('inProgress')">In Progress</button>
      <button class="filter-btn" [class.active]="filterStatus === 'resolved'" (click)="setFilter('resolved')">Resolved</button>
      <button class="filter-btn" [class.active]="filterStatus === 'closed'" (click)="setFilter('closed')">Closed</button>
    </div>
  </div>

  <div class="ticket-table-container">
    <table class="ticket-table">
      <thead>
        <tr>
          <th>Ticket ID</th>
          <th>Subject</th>
          <th>Submitted By</th>
          <th>User Type</th>
          <th>Attachments</th>
          <th>Status</th>
          <th>Actions</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let ticket of tickets">
          <td><span class="ticket-id">{{ ticket.id }}</span></td>
          <td>{{ ticket.subject }}</td>
          <td>{{ ticket.submitter }}</td>
          <td>
            <span
              class="status-badge"
              [ngStyle]="ticket.userType === 'Supplier'
                ? { background: '#57c1eb20', color: '#1a5f7a' }
                : { background: '#ff7e3620', color: '#ff7e36' }"
            >
              {{ ticket.userType }}
            </span>
          </td>
          <td>{{ ticket.attachments.length }} files</td>
          <td>
            <span class="status-badge" [ngClass]="getStatusClass(ticket.status)">{{ ticket.status }}</span>
            <button
              *ngIf="ticket.status === 'Open' || ticket.status === 'In Progress'"
              class="edit-btn"
              type="button"
              style="margin-left: 6px; padding: 4px 8px;"
              (click)="openStatusModal(ticket)"
            >
              <i class="fas fa-pencil-alt"></i>
            </button>
          </td>
          <td>
            <div class="action-buttons">
              <button class="admin-btn view-email-btn" type="button" (click)="openEmailPreview(ticket)">
                <i class="fas fa-envelope"></i>
                Email View
              </button>
              <button class="view-btn" type="button" (click)="openTicketDetails(ticket)">
                <i class="fas fa-eye"></i>
                Details
              </button>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>

  <div class="pagination" style="display:flex; justify-content:flex-end; align-items:center; gap:12px; margin-top: 12px;">
    <div class="page-size" style="display:flex; align-items:center; gap:6px;">
      <span style="font-size: 13px; color: var(--gray-text);">Rows per page</span>
      <select class="form-control" style="width: 58px; padding-left: 17px; height:35px;padding-top: 6px;" [(ngModel)]="limit" (change)="onPageSizeChange()">
        <option [ngValue]="10">10</option>
        <option [ngValue]="20">20</option>
        <option [ngValue]="50">50</option>
      </select>
    </div>
    <div class="page-info" style="font-size: 13px; color: var(--gray-text);">
      Page {{ currentPage }} of {{ totalPagesForStatus }} • {{ currentStatusTotal }} records
    </div>
    <div class="page-buttons" style="display:flex; align-items:center; gap:8px;">
      <button class="filter-btn" type="button" [disabled]="currentPage === 1" (click)="prevPage()">
        <i class="fas fa-chevron-left"></i>
      </button>
      <button class="filter-btn" type="button" [disabled]="currentPage >= totalPagesForStatus" (click)="nextPage()">
        <i class="fas fa-chevron-right"></i>
      </button>
    </div>
  </div>

  <div class="support-info">
    <h3>Support Team Contact</h3>
    <p>
      All support tickets are automatically sent to our dedicated support team at mps&#64;varuna-sentinels.com. The team has
      access to all submitted details including attachments.
    </p>
    <div class="support-contact">
      <div class="contact-item">
        <i class="fas fa-envelope"></i>
        <div>
          <div style="font-weight: 600;">Support Email</div>
          <div>{{ adminEmail }}</div>
        </div>
      </div>
      <!-- <div class="contact-item">
        <i class="fas fa-phone"></i>
        <div>
          <div style="font-weight: 600;">Support Hotline</div>
          <div>+1 (800) MARINE-1</div>
        </div>
      </div> -->
      <div class="contact-item">
        <i class="fas fa-clock"></i>
        <div>
          <div style="font-weight: 600;">Response Time</div>
          <div>Within 24 hours</div>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="status-modal-overlay" *ngIf="showStatusModal">
  <div class="status-modal">
    <div class="status-modal__header">
      <div>
        <div class="status-modal__title">Update Ticket's Status</div>
        <div class="status-modal__subtitle" *ngIf="pendingStatusTicket">
          Ticket {{ pendingStatusTicket.ticketRefNumber || pendingStatusTicket.id }}
        </div>
      </div>
      <button class="status-modal__close" type="button" (click)="closeModals()">
        <i class="fas fa-times"></i>
      </button>
    </div>
    <div class="status-modal__body">
      <label for="statusSelect" class="status-modal__label">Select Status</label>
      <select id="statusSelect" class="form-control" #statusSelect>
        <option *ngFor="let s of statusUpdateOptions" [value]="s">{{ s }}</option>
      </select>
    </div>
    <div class="status-modal__footer">
      <button class="cancel-btn" type="button" (click)="closeModals()">Cancel</button>
      <button class="submit-btn" type="button" (click)="submitStatusUpdate(statusSelect.value)">Update</button>
    </div>
  </div>
</div>
<div class="modal-overlay" *ngIf="showDetailsModal" [class.active]="showDetailsModal">
  <div class="modal">
    <div class="modal-header">
      <h3>Ticket Details</h3>
      <button class="close-modal" type="button" (click)="closeModals()">&times;</button>
    </div>
    <div class="modal-body">
      <div class="ticket-details" *ngIf="selectedTicket">
        <div class="ticket-header">
          <h2>{{ selectedTicket.subject }}</h2>
          <div class="ticket-meta">
            <div class="meta-item">
              <div class="meta-label">TICKET ID</div>
              <div class="meta-value">{{ selectedTicket.id }}</div>
            </div>
            <div class="meta-item">
              <div class="meta-label">STATUS</div>
              <div class="meta-value">
                <span class="status-badge" [ngClass]="getStatusClass(selectedTicket.status)">{{ selectedTicket.status }}</span>
              </div>
            </div>
            <div class="meta-item">
              <div class="meta-label">PRIORITY</div>
              <div class="meta-value" [ngClass]="getPriorityClass(selectedTicket.priority)">{{ selectedTicket.priority }}</div>
            </div>
            <div class="meta-item">
              <div class="meta-label">CATEGORY</div>
              <div class="meta-value">{{ selectedTicket.category }}</div>
            </div>
            <div class="meta-item">
              <div class="meta-label">CREATED</div>
              <div class="meta-value">{{ selectedTicket.created }}</div>
            </div>
          </div>
        </div>

        <div class="ticket-content">
          <div class="ticket-section">
            <h4>Description</h4>
            <div class="description-box" style="white-space: pre-line;">{{ selectedTicket.description }}</div>
          </div>

          <div class="ticket-section">
            <h4>Submitted By</h4>
            <p>{{ selectedTicket.submitter }}</p>
          </div>

          <div class="ticket-section">
            <h4>Attached Documents ({{ selectedTicket.attachments.length }} files)</h4>
            <div class="attachments-container">
              <div class="attachment-card" *ngFor="let attachment of selectedTicket.attachments">
                <div class="attachment-icon">
                  <i [class]="attachment.icon"></i>
                </div>
                <div class="attachment-info">
                  <div class="attachment-name">{{ attachment.name }}</div>
                  <div class="attachment-size">{{ attachment.size }}</div>
                </div>
                <button class="download-btn" type="button" (click)="downloadAttachment(attachment.name)">
                  <i class="fas fa-download"></i>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="modal-overlay" *ngIf="showEmailModal" [class.active]="showEmailModal">
  <div class="modal">
    <div class="modal-header">
      <h3>Email Sent to mps&#64;varuna-sentinels.com</h3>
      <button class="close-modal" type="button" (click)="closeModals()">&times;</button>
    </div>
    <div class="modal-body">
      <div class="email-preview" *ngIf="emailPreview" id="adminEmailPreview">
        <div class="email-header">
          <div class="email-to">To: <span class="email-address">mps&#64;varuna-sentinels.com</span></div>
          <div class="email-to" style="margin-top: 10px;">From: <span class="email-address">{{ emailPreview.fromEmail }}</span></div>
          <div class="email-to">Subject: <strong>{{ emailPreview.subject }}</strong></div>
        </div>

        <div class="email-body">
          <div class="email-section">
            <p><strong>Dear Support Team,</strong></p>
            <p>The following ticket is available in the admin console for review:</p>
          </div>

          <div class="email-section">
            <h4>Ticket Information:</h4>
            <ul style="padding-left: 20px; margin: 10px 0;">
              <li><strong>Ticket ID:</strong> <span>{{ emailPreview.ticketId }}</span></li>
              <li><strong>Submitted By:</strong> <span>{{ emailPreview.submitter }}</span></li>
              <li><strong>Category:</strong> <span>{{ emailPreview.category }}</span></li>
              <li><strong>Priority:</strong> <span>{{ emailPreview.priority }}</span></li>
              <li><strong>Submission Date:</strong> <span>{{ emailPreview.date }}</span></li>
            </ul>
          </div>

          <div class="email-section">
            <h4>Issue Description:</h4>
            <div style="background: #f8f9fa; padding: 15px; border-radius: var(--border-radius); margin: 10px 0;">
              <p>{{ emailPreview.description }}</p>
            </div>
          </div>

          <div class="email-section">
            <h4>Attached Documents:</h4>
            <p>The following documents are attached to this ticket:</p>
            <ol style="padding-left: 20px; margin: 10px 0;">
              <li *ngFor="let attachment of selectedTicket?.attachments">{{ attachment.name }} ({{ attachment.size }})</li>
            </ol>
            <p><em>These files are accessible through the admin dashboard.</em></p>
          </div>

          <div class="email-section">
            <h4>Access Ticket:</h4>
            <p>
              You can view and manage this ticket through the admin dashboard at:
              <strong>https://portal.marine-support.com/admin/tickets/{{ emailPreview.ticketId }}</strong>
            </p>
            <p>Login credentials for admin access have been sent separately.</p>
          </div>

          <div class="email-section">
            <p><strong>Best regards,</strong><br />Marine Portal Support System<br />Automated Notification</p>
          </div>

          <div style="margin-top: 30px; padding-top: 20px; border-top: 1px solid var(--light-gray); font-size: 12px; color: var(--gray-text);">
            <p>This is an automated email. Please do not reply directly to this message.</p>
            <!-- <p>To respond to this ticket, please use the admin dashboard or email: tickets&#64;varuna-sentinel.com</p> -->
          </div>
        </div>
      </div>
    </div>
    <div class="modal-footer">
      <button class="cancel-btn" type="button" (click)="closeModals()">Close</button>
      <button class="submit-btn" type="button" (click)="printEmailPreview()">
        <i class="fas fa-print"></i>
        Print Email
      </button>
    </div>
  </div>
</div>
